import { useEffect } from 'react';
import { useQuery } from '@tanstack/react-query';
import { setTwHolidayOverride } from '@invest-copilot/shared';
import { fetchJSON } from './api-client';

type MarketCalendarResp = {
  tw: { holidays: string[] | null; holidaySource: string };
};

/**
 * 撈 /api/market-calendar，把台股 override 休市清單（NAS 推送的 TWSE 官方行事曆）餵給 shared 的
 * setTwHolidayOverride，讓前端「休市/盤中/倒數」也尊重官方行事曆而非只靠寫死 fallback。
 * 低頻（6 小時），失敗或 NAS 未上線（holidays=null）→ 清 override、shared 自動回退寫死 fallback。
 * 美股是演算法計算、不需 override。
 */
export function useMarketCalendarSync(): void {
  const { data } = useQuery({
    queryKey: ['market-calendar'],
    queryFn: () => fetchJSON<MarketCalendarResp>('/api/market-calendar'),
    staleTime: 6 * 60 * 60 * 1000,
    refetchInterval: 6 * 60 * 60 * 1000,
    refetchOnWindowFocus: false,
    retry: 1,
  });

  useEffect(() => {
    if (data?.tw) setTwHolidayOverride(data.tw.holidays ?? null);
  }, [data]);
}
